import { Component, OnDestroy, OnInit } from '@angular/core';
import { IUser } from '../../../../shared/models/user';
import { ActivatedRoute } from '@angular/router';
import { SrsBallotService } from '../../shared/services/srs-ballot.service';
import { filter, Subscription, take } from 'rxjs';
import { ISrsBallotDetail } from '../../shared/models/sr/srs-ballot-details';
import { AuthService } from '../../../../shared/services/auth.service';
import { UserUtility } from '../../../../shared/utilities/user-utility';
import { ITab } from '../../../controls/tab/tab.component';

@Component({
    selector: 'app-srs-details',
    templateUrl: './srs-details.component.html',
    styleUrl: './srs-details.component.scss',
    standalone: false
})
export class SrsDetailsComponent implements OnInit, OnDestroy{
    currentUser!: IUser;
    isInternalUser: boolean = false;
    loading: boolean = true;
    srsBallotDetail: ISrsBallotDetail | null = null;
    selectedTab: string = '';
    initialTabId: string = 'ballotSummary';
    subscriptions: Subscription = new Subscription();
    visibleTabs: ITab[] = [];

    constructor(
      private route: ActivatedRoute,
      private _SrsBallotService: SrsBallotService,
      private _authService: AuthService
    ) {}


    ngOnInit(): void {
      const isFromDecisionModal = localStorage.getItem('fromDecisionModal');
      if (isFromDecisionModal) {
        this.initialTabId = 'viewVotes';
      }
      localStorage.removeItem('fromDecisionModal');

      this.subscriptions.add(this._authService.currentUserSubject
      .pipe(
        filter(user => !!user),
        take(1)
      )
      .subscribe(user => {
        this.currentUser = user as IUser;
        this.isInternalUser = UserUtility.isInternalUser(this.currentUser);
        this.initialiseTabs();
      }));

      this.subscriptions.add(this.route.params.subscribe(params => {
        const id = params['id'];
        if (id) {
          this.getSRSBallot(id);
        }
      }));
    }

    ngOnDestroy(): void {
      this.subscriptions.unsubscribe();
    }

    onTabChange(tabId: string) {
      this.selectedTab = tabId;
    }

    private getSRSBallot(ballotId: string): void {
      this.loading = true; // Setting loading to true at the start
      this.srsBallotDetail = null;

      this.subscriptions.add(this._SrsBallotService.getSRSBallot(ballotId).subscribe({
        next: (response) => {
          if (response && response.success) {
            this.srsBallotDetail = response.content;
            this.loading = false; // Setting loading to false after data is fetched
          }
        },
        error: (error) => {
          this.loading = false; // To handle cases where an error is caught
          console.error('Error fetching ballot details', error);
        }
      }));
    }

    refreshSRSBallot(ballotId: string) {
      if(ballotId) {
        this.getSRSBallot(ballotId);
      }
    }

    initialiseTabs(): void {
      this.visibleTabs = [
          { id: 'ballotSummary', label: 'Ballot Summary' },
          { id: 'viewVotes', label: 'View Votes' },
      ];

      if (this.isInternalUser) {
          this.visibleTabs.push({ id: 'internalHistory', label: 'Internal History' });
      }
    }
}
